/**
 * App paths for the things ⌘K and the create dialog open, as plain strings so
 * the same value serves navigation and "Copy link" (design 29b).
 *
 * A space is a project with no parent; its own pages live under /spaces.
 */
interface ProjectRef {
  projectKey: string
  parentProjectId: string | null
}

export function taskHref(workspaceSlug: string, taskId: string): string {
  return `/${workspaceSlug}/tasks/${taskId}`
}

export function projectHref(workspaceSlug: string, project: ProjectRef): string {
  return project.parentProjectId
    ? `/${workspaceSlug}/projects/${project.projectKey}`
    : `/${workspaceSlug}/spaces/${project.projectKey.toLowerCase()}`
}

export function pageHref(workspaceSlug: string, project: ProjectRef, pageSlug: string): string {
  return project.parentProjectId
    ? `/${workspaceSlug}/projects/${project.projectKey}/pages/${pageSlug}`
    : `/${workspaceSlug}/spaces/${project.projectKey.toLowerCase()}/pages/${pageSlug}`
}

export function noteHref(
  workspaceSlug: string,
  noteType: 'daily' | 'weekly',
  noteDate: string,
): string {
  return `/${workspaceSlug}/notes/${noteType}/${noteDate}`
}
